<template>
    <v-footer :color="appColor" app dark>
        <span>King's University College</span>
        <v-spacer></v-spacer>
        <span>&copy; 2020</span>
    </v-footer>
</template>

<script>
export default {
    name: 'admin-footer',
    computed: {
        appColor() {
            return '#191b2a';
        }
    }
}
</script>